import React from "react";
import { Link } from "react-router-dom";

const Cancellation = () => {



  return (
    <main>
      {/* breadcrumb start */}
      <section
        className="page-title mt-[80px]"
        style={{ backgroundImage: "url(assets/images/inner/page-title-bg.jpg)" }}
      >
        <div className="auto-container">
          <div className="title-outer">
            <ul className="page-breadcrumb wow fadeInUp" data-wow-delay=".3s">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>Cancellation</li>
            </ul>
            <h1 className="title wow fadeInUp" data-wow-delay=".5s">
              Cancellation
            </h1>
          </div>
        </div>
      </section>
      {/* breadcrumb end */}

      {/* cancellation start  */}
      <section class="about-section fix section-padding">
        <div class="auto-container">
          <div class="row g-4">
            <div class="col-lg-12">
              <p className="font-medium mb-2">
                We believes in helping its customers as far as possible,
                and has therefore a liberal cancellation policy. Under
                this policy:
              </p>
              <ul>
                <li className="mb-2">
                  1. Cancellations will be considered only if the request
                  is made within 7 days of placing the order. However, the
                  cancellation request may not be entertained if the
                  orders have been communicated to the vendors/merchants
                  and they have initiated the process of shipping them.
                </li>
                <li className="mb-2">
                  2. We does not accept cancellation requests for orders
                  already initiated or in transit or completed. However,
                  refund/replacement can be made if the customer
                  establishes that the quality of product/service
                  delivered is not good.
                </li>
                <li className="mb-2">
                  3. In case of improper delivery of services or
                  inaccurate results, please report the same to our
                  Customer Service team. The request will, however, be
                  entertained once the health provider has checked and
                  determined the same at his own end. This should be
                  reported within 7 days of receipt of the
                  product/service.
                </li>
                <li className="mb-2">
                  4. In case you feel that the product/service received is
                  not as promised by us or as per your expectations, you
                  must bring it to the notice of our customer service
                  within 7 days of receiving the product/service. The
                  Customer Service Team after looking into your complaint
                  will take an appropriate decision.
                </li>
                <li className="mb-2">
                  5. In case of any Refunds approved by us, it’ll take 6-8
                  days for the refund to be processed to the end customer.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      {/* cancellation end  */}


    </main>
  );
};

export default Cancellation;
